import * as React from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import "./input-text.styles.css";

const InputTextStyled = styled(TextField)({
  '& label.Mui-focused': {
    color: 'var(--color-primary)'
  },
  '& .MuiFilledInput-root': {
    fontFamily:'var(--font-primary), sans-serif',
    fontSize: "var(--text-medium)",
    borderBottom: "none",
    border: "1px solid var(--text-color-secondary-15)",
    borderRadius: "8px",
    background: "#fff",
    height: "44px",
    paddingTop: "12px",
  },
  '& .MuiInputBase-multiline':{
    height: "100%",
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid var(--color-primary)',
    background: "#fff"
  },
  '& .MuiFilledInput-input': {
    paddingTop: "10px"
  },
  '& .MuiInputLabel-root': {
    fontFamily:'var(--font-primary), sans-serif',
    fontSize: "var(--text-medium)",
    lineHeight: "1rem",
  },
  '& .MuiFilledInput-underline:before': {
    border: 'none',
    opacity: '0',
    background: "#fff"
  },
  '& .MuiFilledInput-underline:after': {
    border: 'none',
  },
  '& div.Mui-error': {
    border: "2px solid red!important",
  }
});

const InputText = React.forwardRef((props, ref) => {
  const [value, setValue] = React.useState('');
  
  const {multiline, name, rows, ...others} = props;
  let inputName=name? name:"text";

  const handleChange = (event) => {
    let curValue = String(event.target.value);
    let maxlength = 200;
    if(curValue.length > maxlength){
      curValue = curValue.substring(0,maxlength);
    } else {
    }
    setValue(curValue);
  };
  
  return (
    <InputTextStyled 
      className='input-text input-text-container' fullWidth 
      id={props.id?props.id:"text"}
      variant="filled" 
      onChange={handleChange} 
      inputRef = {ref}
      value={value}
      label={props.label}
      multiline={multiline?true:false}
      rows={rows}
      inputProps={{
        name:inputName,
        ...others
      }}/>
  );
})

export default InputText;